<template>

<div class="settings_right">
  <div class="form_section"  >
    <div class="form-container">
      <div class="vx-row">
      formsandlettersSettings
      </div>
    
    </div>
    <div class="form-footer">
      
     
    </div>
  </div>
</div>
     
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker-inv";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import FileUpload from "vue-upload-component/src";
import * as _ from "lodash";
import { InfoIcon } from 'vue-feather-icons'
export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  },
  directives: {},
  components: {
    VuePhoneNumberInput,
    FileUpload,
    moment,
    Datepicker,
    InfoIcon
  },
};
</script>